import { FC, useEffect, useState } from "react";
import { Control, FieldValues } from "react-hook-form";
import {
  FormController,
  MuiBox,
  MuiGrid,
  MuiSelect,
  MuiTextField,
} from "../../../../../../../components";
import { useSiteCore } from "../../../../../../../hooks/useSiteCore";
import { activitiesAndDeliverablesSiteCoreKeys } from "../../../../../siteCore/SiteCoreKeys";

import { UnitTypesKey } from "../../../../../../../helpers/constants/siteCoreKeys";
import { useNavigationSiteCore } from "../../../../../../../hooks/useNavigationSiteCore";
import {
  CreateActivityDefaultFormKeys,
  CreateActivityDefaultProps,
} from "../../../modelsAndSchemas/models";
interface CreateActivityDefaultTabProps extends FieldValues {
  control: Control<CreateActivityDefaultProps>;
  pageId: string;
  unitValue?: string;
}

export const CreateActivityDefault: FC<CreateActivityDefaultTabProps> = ({
  control,
  pageId,
  unitValue = "",
}) => {
  const gridSize = { md: 4, sm: 6, xs: 12 };
  const { commonLabels, fetchLabel, fetchDropdownValues } = useSiteCore();
  const { commonARIALabel } = useNavigationSiteCore();

  const [selectedUnit, setSelectedUnit] = useState<string>("");

  useEffect(() => {
    setSelectedUnit(unitValue);
  }, [unitValue]);

  // Handle change in unit selection
  const handleUnitChange = (value: string) => {
    setSelectedUnit(value);
  };

  const renderMeasurement = (
    measurementOtherMinuteName: string,
    measurementOther: string,
  ) => {
    return (
      <>
        {selectedUnit === UnitTypesKey.Minutes && (
          <FormController
            control={control}
            name={
              measurementOtherMinuteName as keyof CreateActivityDefaultProps
            }
          >
            <MuiSelect
              label={fetchLabel(
                activitiesAndDeliverablesSiteCoreKeys.defaultActivityKey,
                activitiesAndDeliverablesSiteCoreKeys.minutes,
              )}
              options={fetchDropdownValues(
                activitiesAndDeliverablesSiteCoreKeys.defaultActivityKey,
                activitiesAndDeliverablesSiteCoreKeys.minutesList,
              )}
              isMandatory
              id={`${pageId}-${measurementOtherMinuteName}`}
              placeholder={commonLabels.selectPlaceHolder}
              requiredARIALabel={commonARIALabel.required}
            />
          </FormController>
        )}

        {(selectedUnit === UnitTypesKey.Count ||
          selectedUnit === UnitTypesKey.Days) && (
          <FormController
            control={control}
            name={measurementOther as keyof CreateActivityDefaultProps}
          >
            <MuiTextField
              label={fetchLabel(
                activitiesAndDeliverablesSiteCoreKeys.defaultActivityKey,
                selectedUnit === UnitTypesKey.Count
                  ? activitiesAndDeliverablesSiteCoreKeys.quantity
                  : activitiesAndDeliverablesSiteCoreKeys.numberofDays,
              )}
              id={`${pageId}-${measurementOther}`}
              type="number"
              placeholder={commonLabels.inputPlaceHolder}
              isMandatory
              inputNumberWithoutDecimal
              requiredARIALabel={commonARIALabel.required}
              data-testid="activity-measurement-other"
            />
          </FormController>
        )}
      </>
    );
  };

  return (
    <MuiBox data-testid="activity-tab-default">
      <MuiGrid container className="activity-tab-default">
        <MuiGrid size={gridSize}>
          <FormController
            control={control}
            name={CreateActivityDefaultFormKeys.units}
          >
            <MuiSelect
              label={fetchLabel(
                activitiesAndDeliverablesSiteCoreKeys.defaultActivityKey,
                activitiesAndDeliverablesSiteCoreKeys.units,
              )}
              options={fetchDropdownValues(
                activitiesAndDeliverablesSiteCoreKeys.defaultActivityKey,
                activitiesAndDeliverablesSiteCoreKeys.unitLists,
              )}
              visibleDefaultSelectOption
              disabled
              value=""
              id={`${pageId}-${CreateActivityDefaultFormKeys.units}`}
              isMandatory
              placeholder={commonLabels.selectPlaceHolder}
              onChange={(e) => handleUnitChange(e.target.value as string)}
              requiredARIALabel={commonARIALabel.required}
              data-testid="activity-units-select"
            />
          </FormController>
        </MuiGrid>
        <MuiGrid size={gridSize}>
          {renderMeasurement(
            CreateActivityDefaultFormKeys.measurementMinute,
            CreateActivityDefaultFormKeys.measurementOther,
          )}
        </MuiGrid>
      </MuiGrid>
    </MuiBox>
  );
};
